<template functional>
  <div class="sanction-field">
    <span class="sanction-field__label">{{ props.label }}:</span>
    <span class="sanction-field__value">{{ props.value || getNoDataValue }}</span>
  </div>
</template>

<script>
import { sanctionsStatusMessage } from '@/entities/insurance';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    getNoDataValue() {
      return sanctionsStatusMessage.no_data;
    },
  },
};
</script>

<style scoped lang="scss">
.sanction-field {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;

  &__label {
    font-weight: 600;
    color: #374151;
    white-space: nowrap;
  }

  &__value {
    color: #111827;
    word-break: break-word;
  }
}
</style>